import { render, staticRenderFns } from "./exchange-marzs.vue?vue&type=template&id=39211324&lang=pug"
import script from "./exchange-marzs.vue?vue&type=script&lang=js"
export * from "./exchange-marzs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports